import React, { memo } from 'react';
import Fraction from 'fraction.js';
import t from 'common/i18n';

import './Info.scss';

const toFraction = (num) => {
  const result = Fraction(num).simplify([0.1]).toFraction();
  return result.length === 1 ? `${result}/1` : result;
};

// TODO: refactor to a common util (there's similar function in G-Drive tab, service/helpers)
const getDuration = (asset) =>
  asset.duration
    ? {
        seconds: asset.duration % 60 < 10 ? `0${asset.duration % 60}` : asset.duration % 60,
        minutes: Math.floor(asset.duration / 60) < 10 ? `0${Math.floor(asset.duration / 60)}` : Math.floor(asset.duration / 60),
      }
    : null;

const Info = (props) => {
  const { format, asset, selectedVariant, withDescription } = props;
  const duration = getDuration(asset);

  return (
    <li className={props.className}>
      <ul className="pl0 m-0 list">
        {format !== 'mp4' && (
          <li className="flex pt3 pb3">
            <span className="w-30">{t('shutterstock.purchase_page.aspect_ratio')}</span>
            <span className="max-w-70 o-50">{toFraction(asset.aspect)}</span>
          </li>
        )}

        {format === 'mp4' && duration && (
          <li className="flex pt3 pb3">
            <span className="w-30">{t('shutterstock.purchase_page.duration')}</span>
            <span className="max-w-70 o-50">
              {duration.minutes}:{duration.seconds}
            </span>
          </li>
        )}

        <li className="flex pt3 pb3">
          <span className="w-30">{t('shutterstock.purchase_page.author')}</span>
          <span className="max-w-70 o-50">{asset.contributor.display_name}</span>
        </li>

        {withDescription && (
          <li className="flex pt3 pb3">
            <span className="w-30">{t('shutterstock.purchase_page.description')}</span>
            <span className="max-w-70 o-50">{asset.subtitle}</span>
          </li>
        )}

        {format === 'mp4' && selectedVariant && selectedVariant.fps && (
          <li className="flex pt3 pb3">
            <span className="w-30">{t('shutterstock.purchase_page.fps')}</span>
            <span className="max-w-70 o-50">{Math.round(selectedVariant.fps || 0)}</span>
          </li>
        )}
      </ul>
    </li>
  );
};

export default memo(Info);
